<p-card header="Hot Numbers">
  <button
    pButton
    pRipple
    label="ADD"
    class="p-button-success mb-3"
    (click)="onClickAdd()"
  ></button>
  <div class="card">
    <p-table
      #dt1
      [value]="hotnumbers"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50, 100, 1000, 10000]"
      [globalFilterFields]="['combination']"
    >
      <ng-template pTemplate="caption">
        <div class="flex">
          <!-- <button
          pButton
          label="Clear"
          class="p-button-outlined"
          icon="pi pi-filter-slash"
          (click)="clear(dt1)"
        ></button> -->
          <span class="p-input-icon-left ml-auto">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
              placeholder="Search Combination"
            />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Combinations</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-hot>
        <tr>
          <td>{{ hot.combination }}</td>
          <td>
            <p-button
              icon="pi pi-trash"
              styleClass="p-button-rounded p-button-danger"
              (onClick)="Delete(hot.combination)"
            ></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-dialog header="ADD" [(visible)]="visible" [style]="{ width: '20vw' }">
  <div class="grid">
    <div class="col-12">
      <div class="flex flex-column gap-2">
        <label htmlFor="code">Combination</label>
        <input
          pInputText
          id="code"
          aria-describedby="code-help"
          [(ngModel)]="combination"
          maxlength="3"
        />
      </div>
    </div>
    <!-- <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="name">Name</label>
        <input
          pInputText
          id="name"
          aria-describedby="name-help"
          [(ngModel)]="Name"
        />
      </div>
    </div> -->
    <!-- <div class="col-4">
        <div class="flex flex-column gap-2">
          <label htmlFor="">Lastname</label>
          <input
            pInputText
            id="lastname"
            aria-describedby="username-help"
            [(ngModel)]="value"
          />
        </div>
      </div> -->
  </div>
  <div class="flex flex-row-reverse flex-wrap">
    <button
      pButton
      pRipple
      label="SAVE"
      class="p-button-info mt-3 ml-2"
      (click)="Save()"
    ></button>
  </div>
</p-dialog>
